<template>
  <div class="tab-pane-content">
    <div class="section-header">
      <div class="section-header__icon section-header__icon--danger">
        <feather-icon
          icon="ShieldIcon"
          size="20"
        />
      </div>
      <div>
        <h4 class="mb-0">
          Change Password
        </h4>
        <small class="text-muted">Ensure your account is using a strong password for security</small>
      </div>
    </div>

    <b-row class="mt-2">
      <b-col
        cols="12"
        md="6"
        class="mb-1"
      >
        <label class="form-label-icon">
          <feather-icon
            icon="LockIcon"
            size="14"
            class="mr-50 text-danger"
          />
          Current Password
        </label>
        <b-input-group>
          <b-form-input
            v-model="passwordForm.current_password"
            :type="showPass.current ? 'text' : 'password'"
            placeholder="Enter current password"
          />
          <b-input-group-append>
            <b-button
              variant="outline-secondary"
              @click="showPass.current = !showPass.current"
            >
              <feather-icon
                :icon="showPass.current ? 'EyeOffIcon' : 'EyeIcon'"
                size="14"
              />
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-col>

      <b-col
        cols="12"
        md="6"
        class="mb-1"
      />

      <b-col
        cols="12"
        md="6"
        class="mb-1"
      >
        <label class="form-label-icon">
          <feather-icon
            icon="KeyIcon"
            size="14"
            class="mr-50 text-primary"
          />
          New Password
        </label>
        <b-input-group>
          <b-form-input
            v-model="passwordForm.new_password"
            :type="showPass.new ? 'text' : 'password'"
            placeholder="Enter new password"
          />
          <b-input-group-append>
            <b-button
              variant="outline-secondary"
              @click="showPass.new = !showPass.new"
            >
              <feather-icon
                :icon="showPass.new ? 'EyeOffIcon' : 'EyeIcon'"
                size="14"
              />
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-col>

      <b-col
        cols="12"
        md="6"
        class="mb-1"
      >
        <label class="form-label-icon">
          <feather-icon
            icon="KeyIcon"
            size="14"
            class="mr-50 text-primary"
          />
          Confirm New Password
        </label>
        <b-input-group>
          <b-form-input
            v-model="passwordForm.new_password_confirmation"
            :type="showPass.confirm ? 'text' : 'password'"
            placeholder="Re-enter new password"
          />
          <b-input-group-append>
            <b-button
              variant="outline-secondary"
              @click="showPass.confirm = !showPass.confirm"
            >
              <feather-icon
                :icon="showPass.confirm ? 'EyeOffIcon' : 'EyeIcon'"
                size="14"
              />
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-col>
    </b-row>

    <b-alert
      show
      variant="warning"
      class="mt-1 mb-0"
    >
      <div class="alert-body d-flex align-items-center">
        <feather-icon
          icon="AlertTriangleIcon"
          size="16"
          class="mr-75"
        />
        <span>Leave password fields empty if you don't want to change your password.</span>
      </div>
    </b-alert>

    <div class="d-flex justify-content-end mt-2 pt-1 border-top">
      <b-button
        variant="primary"
        class="profile-primary-btn"
        :disabled="isSaving"
        @click="updatePassword"
      >
        <b-spinner
          v-if="isSaving"
          small
          class="mr-50"
        />
        <feather-icon
          v-else
          icon="ShieldIcon"
          size="14"
          class="mr-50"
        />
        Update Password
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SecurityTab',
  props: {
    passwordForm: {
      type: Object,
      required: true,
    },
    showPass: {
      type: Object,
      required: true,
    },
    isSaving: {
      type: Boolean,
      default: () => false,
    },
    updatePassword: {
      type: Function,
      required: true,
    },
  },
}
</script>
<!-- eof -->
<!-- eof2 -->
